import { Action, Reducer } from "redux";
import { AppThunkAction, remoteActions } from ".";

export const DAMAGE_FREE_YEAR_CHANGED = "DAMAGE_FREE_YEAR_CHANGED";
export const DAMAGE_FREE_YEAR_INVALID = "DAMAGE_FREE_YEAR_INVALID";
export const DAMAGE_FREE_YEAR_VALID = "DAMAGE_FREE_YEAR_VALID";

export interface DamageFreeYearValue {
  value: boolean;
  text: string;
}

export interface DamageFreeYearState {
  title: string;
  /**
   * TRUE means there was not accidents!
   */
  selected?: boolean;
  questionVisible: boolean;
  values: DamageFreeYearValue[];
  description?: { title: string; text: string };
  requiredErrorMessage?: string;
  showError: boolean;
}

// for dev. purposes
export const defaults: DamageFreeYearState = {
  // localize;
  title: "Har du kört skadefritt de senaste två åren?",
  questionVisible: true,
  selected: undefined,
  values: [
    {
      value: true,
      text: "Ja",
    },
    {
      value: false,
      text: "Nej",
    },
  ],
  requiredErrorMessage: "Vi behöver veta om du kört skadefritt eller inte.",
  showError: false,
};

export type DamageFreeYearAction = {
  type: typeof DAMAGE_FREE_YEAR_CHANGED | typeof DAMAGE_FREE_YEAR_INVALID | typeof DAMAGE_FREE_YEAR_VALID;
  payload: { value: boolean | undefined };
};

export const reducer: Reducer<DamageFreeYearState> = (state: DamageFreeYearState = defaults, input: Action): DamageFreeYearState => {
  const action = input as DamageFreeYearAction;

  switch (action?.type) {
    case DAMAGE_FREE_YEAR_CHANGED:
      const newValue = action.payload.value;
      if (newValue == null) {
        return state;
      }
      return { ...state, selected: newValue, showError: false };
    case DAMAGE_FREE_YEAR_INVALID: {
      return {
        ...state,
        showError: true,
      };
    }

    case DAMAGE_FREE_YEAR_VALID: {
      return {
        ...state,
        showError: false,
      };
    }

    default:
      return state;
  }
};

export const actions = {
  damageFreeYearChanged:
    (value: unknown): AppThunkAction<DamageFreeYearAction | AppThunkAction<{}>> =>
    dispatch => {
      dispatch({
        type: DAMAGE_FREE_YEAR_CHANGED,
        payload: { value: value as boolean },
      });

      dispatch(remoteActions.requestPriceData());
    },
};
